import generalSection from "../_section/section.class";
import {adminHomeInsuranceUpload, userHomeInsuranceUpload} from "./upload";
import problem from "../_section/section-problem.class";
import DataForm from "./DataForm";
import ApplicationForm from "./ApplicationForm";

export class userHomeInsuranceSection extends generalSection {
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userHomeInsuranceUpload);
        // Add missing date error

    }
}

export class adminHomeInsuranceSection extends userHomeInsuranceSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminHomeInsuranceUpload);
         this.DataForm = DataForm
        this.ApplicationForm = ApplicationForm
        this.activeUpload = this.activeUploads.find(u=> u.allValuesAnswered && u.isVerifiable)
        this.sortByDateProp('startDate');
        this.setProblems( this.getProblems());
    }
    getProblems (){
        const clean = s =>
            s
                .toLowerCase()
                .replace(/\b(mr|mrs|ms|miss|dr|prof)\b/g, "") // remove standalone titles
                .replace(/[^a-z\- ]/g, "")                    // keep letters, hyphens, spaces
                .replace(/\s+/g, " ")                         // collapse spaces only
                .trim();
       // Names Match
        const namesPresent = () => {

            const haystack = clean(this.activeUpload.values.customerNames);
            const match = (name) => haystack.includes(name);

            const app1 = this.mortgage.applicant1.fullName;
            const n1 = clean(app1);
            if (this.mortgage.twoApplicants){
                const app2 = this.mortgage.applicant2.fullName;
                const n2 = clean(app2);
                return match(n1) && match(n2);
            }
            return match(n1);
        }

        //Address Match
        const addressMatch = () => {
            const cleanAddress = s =>
                s
                    .toLowerCase()
                    .replace(/\b(co.|co|county)\b/g, "") // remove standalone titles
                    .replace(/[^a-z\- ]/g, "")                    // keep letters, hyphens, spaces
                    .replace(/\s+/g, " ")                         // collapse spaces only
                    .trim();
            const address= cleanAddress(this.mortgage.property.address)
            const propAddress = cleanAddress(this.activeUpload.values.propertyAddress);

            return propAddress === address;
        }




        const problems =  this.problemsList.singleUploadUserProblems();

        if (!problems.length){
            if (!namesPresent()){
                problems.push(new problem({
                    type: 'DATA',
                    title: 'Data Mismatch',
                    reason: 'Customer names do not match the application',
                    uploadIDs: [this.activeUpload.id],
                    message: `Customer names in the upload do not match the mortgage application`,
                }))

            }
            if (this.activeUpload?.values?.propertyAddress && !addressMatch() ){
                problems.push(new problem({
                    type: 'DATA',
                    title: 'Data Mismatch',
                    reason: 'Property address does not match the valuation',
                    uploadIDs: [this.activeUpload.id],
                    message: `${this.activeUpload.values.propertyAddress.toUpperCase()}\n does not equal\n ${this.mortgage.property.address.toUpperCase()}`,
                }))
            }
            if (this.activeUpload?.values?.sumInsured){
                const sumInsured = parseFloat(this.activeUpload.values.sumInsured)
                const reinstatementValue = this.mortgage.property.valuation2ReinstatementValue || this.mortgage.property.reinstatementValue;
                if (reinstatementValue && sumInsured < reinstatementValue){
                    problems.push(new problem({
                        type: 'DATA',
                        title: 'Insufficient Cover',
                        reason: 'Sum insured is less than the reinstatement value of the property',
                        uploadIDs: [this.activeUpload.id],
                        message: `The sum insured of ${sumInsured.toLocaleString('en-GB', {style: 'currency', currency: 'GBP'})} is less than the reinstatement value of the property (${reinstatementValue.toLocaleString('en-GB', {style: 'currency', currency: 'GBP'})})`,
                    }))
                }
            }
            if (this.activeUpload?.values?.bankName){
                const bankName = this.activeUpload.values.bankName.toLowerCase().trim();
                if (bankName !== this.mortgage.activeSubmission.lenderCode){
                    problems.push(new problem({
                        type: 'DATA',
                        title: 'Data Mismatch',
                        reason: 'Lender\'s interest does not match the lender',
                        uploadIDs: [this.activeUpload.id],
                        message: `The insurer bank (${this.activeUpload.values.bankName}) does not match the lender (${this.mortgage.activeSubmission.lenderCode.toUpperCase()})`,
                    }))
                }
            }


        }
        // if (!problems.length){
        //     // Amount Mismatch
        //     const applicationAmount = this.mortgage.requirement.helpToBuySchemeAmount
        //     if (this.amount && applicationAmount && this.amount !== applicationAmount) {
        //         problems.push(new problem({
        //             type: 'BUNDLE',
        //             title: 'Data Mismatch',
        //             reason: 'Application amount doesnt match the upload',
        //             uploadIDs: [this.activeUpload.id],
        //             message: `${this.amount} does not match the application amount (${applicationAmount})`,
        //         }))
        //     }
        // }
        return problems;
    }
    getSectionSummary = () => {
        return [
            {
                name: this.personalTitle,
                tags: [{
                    name: 'Start Date',
                    value: this.activeUpload?.values?.startDate?.format('D MMM YYYY') || 'Not Provided'
                },
                    {
                        name: 'Sum Insured',
                        value: this.activeUpload?.values?.sumInsured?.toLocaleString('en-IE', {style: 'currency', currency: 'EUR'}) || 'Not Provided'
                    },
                    {
                        name: 'Bank Name',
                        value: this.activeUpload?.values?.bankName || 'Not Provided'
                    }
                ]
            }
        ]
    }
}